import ConfigManager from 'components/config/ConfigManager'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { DATICONDUCENTE_CONDIVISO } from 'configuration/datiConducente'
import Breadcrumbs from '../Breadcrumbs'

export default function BreadcrumbsDatiConducente({ conf = null }) {
  // Se conf è già fornito, lo usiamo direttamente
  if (conf) {
    return <Breadcrumbs sx={{ mb: 3 }} {...conf} />
  }

  // Altrimenti, utilizziamo ConfigManager e renderizziamo BaseBreadcrumbs solo quando i dati sono pronti
  return (
    <ConfigManager elenchiConfig={[ELENCHI.CFG_DATICONDUCENTE_CONDIVISO]}>
      {propsConfig => <Breadcrumbs {...(propsConfig.val(DATICONDUCENTE_CONDIVISO.BREADCRUMBS) ?? null)} />}
    </ConfigManager>
  )
}